/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PieChartProps } from '../../PieChart.props';

export const getPieChartLegendOptions = (options: PieChartProps): Highcharts.Options => {
  const { hideLegend } = options;
  return {
    legend: {
      enabled: hideLegend ? false : true,
    },
  };
};
